import React, { createContext, ReactNode, useContext } from "react";

import { IDevelopmentPriceNoteService } from "../types/services/development-price-note-service";

const DevelopmentPriceNoteServiceContext = createContext<
  IDevelopmentPriceNoteService
>(undefined as any);

interface DevelopmentPriceNoteServiceProviderProps {
  children: ReactNode;
  service: IDevelopmentPriceNoteService;
}

function DevelopmentPriceNoteServiceProvider(
  props: DevelopmentPriceNoteServiceProviderProps,
) {
  const { children, service } = props;

  return (
    <DevelopmentPriceNoteServiceContext.Provider value={service}>
      {children}
    </DevelopmentPriceNoteServiceContext.Provider>
  );
}

function useDevelopmentPriceNoteService() {
  return useContext(DevelopmentPriceNoteServiceContext);
}

export { DevelopmentPriceNoteServiceProvider, useDevelopmentPriceNoteService };
